import React, { useState } from 'react'
import axios from 'axios'

const DailyReport = ({ setShowReport, userDetails }) => {
    const [formData, setFormData] = useState({
        visit_date: '',
        site: '',
        reason: '',
        places: ''
    })

    // handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({
          ...formData,
          [name]: value
        })
      }

      const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedData = {...formData, user_id: userDetails.id};
    
        try {
          await axios.post('http://localhost:3002/api/daily-report', updatedData, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          setShowReport(false);
          alert('Report Submitted.');
          setFormData({ visit_date: '', site: '', reason: '', places: '' });
        }
        catch (error) {
          console.log('Cannot submit report', error.response || error.message);
        }
      };
    

  return (
    <>
          <section className='profile-area' onClick={() => setShowReport(false)}>
            <div className='profile-area-inner' onClick={(e) => e.stopPropagation()}>
              <i className="fa-solid fa-clipboard profile-icon"></i><br />
              <p className='fw-bold my-3'>Daily Report</p>


              <form className="row g-3 mt-4" onSubmit={handleSubmit}>
                <div className="col-12">
                  <input type="date" className="form-input" name="visit_date" value={formData.visit_date} placeholder='Visit Date' onChange={handleChange} required />
                </div>
                <div className="col-12">
                  <input type="text" className="form-input" name='site' value={formData.site} placeholder="Today's Site Visit Name" onChange={handleChange} required />
                </div>
                <div className="col-12">
                  <input type="text" className="form-input" name='reason' value={formData.reason} placeholder='Reason of Visit' onChange={handleChange} required />
                </div>
                <div className="col-12">
                  <input type="text" className="form-input" name='places' value={formData.places} placeholder='Places Visited (seperate places using commas)' onChange={handleChange} required />
                </div>

                <div className="col-12 my-4">
                  <button type="submit" className="admin-btn py-3 rounded w-100">Submit Report</button>
                </div>
              </form>
              {/* form ends */}

            </div>
          </section>
    </>
  )
}

export default DailyReport
